<template>
  <card class="flex-wrap mbo-4" customClass="card-vault-statistic">
    <!-- <template #header>
      <div class="flex-wrap header-vault-statistic">
        <div>
          <img
            src="/icon/Calendar.svg"
            style="width: 22px; vertical-align: top !important"
          />
          <date-range-picker
            v-model="pickerDates"
            :locale-data="{ format: 'mm-dd-yyyy', separator: ' - ' }"
            opens="left"
            :ranges="false"
            :auto-apply="true"
          >
            <template v-slot:input="picker">
              <span>{{ pickerDates.startDate | date }}</span>
              <img src="/icon/chevron-down.svg" style="margin-top: -5px" />
              <span style="margin: auto 16px">TO</span>
              <span>{{ pickerDates.endDate | date }}</span>
              <img src="/icon/chevron-down.svg" style="margin-top: -5px" />
            </template>
          </date-range-picker>
        </div>
      </div>
    </template> -->
    <div class="w-100" v-if="vault">
      <b-row no-gutters class="justify-content-between" style="row-gap: 20px">
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">total number of deposits</div>
          <div class="text-body">{{ vault.total_deposit }}</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">total number of accounts</div>
          <div class="text-body">{{ vault.account_deposit }}</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">value of deposits (USD)</div>
          <div class="text-body">{{ value_of_deposit }}</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">total number of withdrawals</div>
          <div class="text-body">{{ vault.total_withdrawal }}</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">total number of accounts</div>
          <div class="text-body">{{ vault.account_withdrawal }}</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">value of withdrawals (USD)</div>
          <div class="text-body">{{ value_of_withdrawal }}</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">maturities in the money</div>
          <div class="text-body">-</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">APY (Est.)</div>
          <div class="text-body">{{ vault.apy }}%</div>
        </b-col>
        <b-col cols="4" class="box-statistic-val">
          <div class="text-head">premiums paid out (USD)</div>
          <div class="text-body">{{ total_profit }}</div>
        </b-col>
      </b-row>
    </div>
    <div class="mt-4 w-100"></div>
  </card>
</template>

<script>
import Card from "../Card.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import AdminCard from "./UI/AdminCard.vue";
import AdminDatatable from "./UI/Table/AdminDatatable.vue";
import AdminCopyDropdown from "./UI/Table/AdminCopyDropdown.vue";
import AdminButton from "./UI/Button/AdminButton.vue";
import AdminVaultStateDropdown from "./UI/Table/AdminVaultStateDropdown.vue";
import AdminHistoryFilter from "./UI/Table/AdminHistoryFilter.vue";
import AdminTextField from "./UI/Input/AdminTextField.vue";
import { mapState } from "vuex";

export default {
  components: {
    Card,
    DateRangePicker,
    AdminCard,
    AdminDatatable,
    AdminButton,
    AdminVaultStateDropdown,
    AdminCopyDropdown,
    AdminHistoryFilter,
    AdminTextField,
  },
  data() {
    const startDate = new Date(new Date().getFullYear(), 0, 1);
    const endDate = new Date();
    //endDate.setDate(endDate.getDate() + 6);
    return {
      pickerDates: {
        startDate,
        endDate,
      },

      headers: [
        // { text: "Admin ID", value: "admin_id", orderable: true, clicked: true },
        {
          text: "Wallet Address",
          value: "wallet_address",
          orderable: true,
          sloted: true,
        },
        { text: "Action", value: "action", orderable: true, sloted: true },
        {
          text: "State",
          value: "state",
          orderable: true,
          sloted: true,
        },
        { text: "Amount", value: "amount", orderable: true, sloted: true },
        {
          text: "Transaction ID",
          value: "trx_id",
          orderable: true,
          sloted: true,
        },
        { text: "Currency", value: "currency", orderable: true },
      ],
      filter: {
        search: null,
        action: [],
        currency: [],
      },
    };
  },
  filters: {
    date(date) {
      return new Intl.DateTimeFormat("en-US").format(date);
    },
  },
  computed: {
    ...mapState("vault_detail", ["vault"]),
    value_of_deposit() {
      if (this.vault.total_deposit_amount) {
        if (this.vault.type == "put_selling") {
          return this.moneyFormat(this.vault.total_deposit_amount);
        } else {
          return this.moneyFormat(
            this.vault.total_deposit_amount * this.vault.price
          );
        }
      } else return 0;
    },
    value_of_withdrawal() {
      if (this.vault.total_withdrawal_amount) {
        if (this.vault.type == "put_selling") {
          return this.moneyFormat(this.vault.total_withdrawal_amount);
        } else {
          return this.moneyFormat(
            this.vault.total_withdrawal_amount * this.vault.price
          );
        }
      } else return 0;
    },
    total_profit() {
      if (this.vault.vault_detail) {
        if (this.vault.type == "put_selling") {
          return this.moneyFormat(this.vault.vault_detail.premium_price);
        } else {
          return this.moneyFormat(
            this.vault.vault_detail.premium_price * this.vault.price
          );
        }
      } else return 0;
    },
  },
};
</script>

<style lang="scss">
@import "./resources/sass/app.scss";

.card-vault-statistic {
  border: 1px solid transparent !important;
  border-radius: 4px !important;
  background: $primary-4;
  padding: 0 !important;
  .header-vault-statistic {
    border-bottom: 1px solid #eaedf0;
    padding-bottom: 13px;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .box-statistic-val {
    font-family: Exo;
    font-style: normal;
    color: #222222;
    text-align: center;
    padding: 15px 6.25px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    border: 1px solid #eaedf0;
    box-sizing: border-box;
    border-radius: 4px;
    flex: 0 0 32% !important;
    .text-head {
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      text-align: center;
    }
    .text-body {
      font-weight: bold;
      font-size: 40px;
      line-height: 53px;
      text-align: center;
      letter-spacing: 0.5px;
      text-transform: capitalize;
    }
  }
  .vue-daterange-picker {
    .form-control,
    .form-control:focus,
    .form-control:active {
      min-width: 150px;
      width: max-content;
      font-family: Exo;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      color: #222222;
      padding: 3px 10px 3px 10px;
      border: 1px solid transparent;
      box-sizing: border-box;
      border-radius: 1px;
      background: #ffffff;
    }
    .daterangepicker .calendar-table th {
      color: rgba(0, 0, 0, 0.6);
    }
    .daterangepicker .calendar-table td {
      color: #222222;
    }
    .daterangepicker td.off,
    .daterangepicker td.off.end-date,
    .daterangepicker td.off.in-range,
    .daterangepicker td.off.start-date {
      color: #999 !important;
    }
    .daterangepicker td.active,
    .daterangepicker td.active:hover {
      background-color: #27ae60;
      border-color: transparent;
      color: #fff !important;
    }
  }
}
</style>
